"use client";

import type { ReactElement } from "react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import { ButtonPreset } from "@/constants/componentPresets";
import { Cbutton } from "../Cbutton";
import type { ScrollHintState } from "./timeline-root-types";

const TIMELINE_CONTROL_ICON_SIZE = 20;
const TIMELINE_CONTROL_PADDING = 6;

export interface TimelineControlsProps {
  onScrollNext: () => void;
  onScrollPrev: () => void;
  scrollHintState: ScrollHintState;
}

export function TimelineControls({
  onScrollNext,
  onScrollPrev,
  scrollHintState,
}: TimelineControlsProps): ReactElement {
  return (
    <>
      <Cbutton
        rootAttributes={{ "data-el": "Cmarkdowntimeline/TimelineControls/PreviousTrigger" }}
        preset={ButtonPreset.Ghost}
        icon={IconChevronLeft}
        iconSize={TIMELINE_CONTROL_ICON_SIZE}
        padding={TIMELINE_CONTROL_PADDING}
        disabled={!scrollHintState.showLeft}
        onClick={onScrollPrev}
      />
      <Cbutton
        rootAttributes={{ "data-el": "Cmarkdowntimeline/TimelineControls/NextTrigger" }}
        preset={ButtonPreset.Ghost}
        icon={IconChevronRight}
        iconSize={TIMELINE_CONTROL_ICON_SIZE}
        padding={TIMELINE_CONTROL_PADDING}
        disabled={!scrollHintState.showRight}
        onClick={onScrollNext}
      />
    </>
  );
}
